<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex d-flex xs12 sm6 md9>
                <v-card color="white">
                <v-card-title primary class="title">{{ mainPartTitle }}</v-card-title>
                <v-card-text>
                    <p>{{ mainPartInfo1 }}</p>
                    <p>{{ mainPartInfo2 }}</p>
                    <p>{{ mainPartInfo3 }}</p>
                    <p>{{ mainPartInfo4 }}</p>
                </v-card-text>
                </v-card>
            </v-flex>
            <v-flex d-flex xs12 sm6 md3>
                <v-card color="white">
                <v-card-text>
                    <p>{{ smallPart1 }}</p>
                    <p>{{ smallPart2a }}</p>
                    <p>{{ smallPart2b }}</p>
                    <p>{{ smallPart2c }}</p>

                    <p>{{ smallPart3a }}</p>
                    <p>{{ smallPart3b }}</p>
                    <p>{{ smallPart3c }}</p>

                    <p>{{ smallPart4a }}</p>
                    <p>{{ smallPart4b }}</p>
                    <p>{{ smallPart4c }}</p>
                </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  //import { mapState } from 'vuex'

  export default {
    props: {
        smallPart1: String,

        smallPart2a: String,
        smallPart2b: String,
        smallPart2c: String,

        smallPart3a: String,
        smallPart3b: String,
        smallPart3c: String,

        smallPart4a: String,
        smallPart4b: String,
        smallPart4c: String,

        mainPartTitle: String,
        mainPartInfo1: String,
        mainPartInfo2: String,
        mainPartInfo3: String,
        mainPartInfo4: String,

    },
  }
</script>
